import { useState } from "react";
import LocContext from "./locContext";
import axios from "axios";
import CryptoJS from "crypto-js";

const SECRET_KEY = "countrycode351"; // 👈 keep it secure, not hardcoded in production

const LocState = (props) => {
    // 🔹 Helper functions
    const encryptData = (data) => {
        return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
    };

    const decryptData = (cipherText) => {
        try {
            const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } catch (error) {
            return null;
        }
    };

    // 🔹 Get location from localStorage (decrypted)
    const encryptedLocation = localStorage.getItem("aerial_user_dataid");
    const location = encryptedLocation ? decryptData(encryptedLocation) : null;

    const fetchCountry = async () => {
        try {
            const response = await axios.get("https://ipinfo.io/json");
            const data = response.data;

            if (!location || location !== data.country) {
                const encryptedCountry = encryptData(data.country);
                localStorage.setItem("aerial_user_dataid", encryptedCountry);
            }
        } catch (error) {
            console.error("Error fetching country:", error);
        }
    };

    fetchCountry();

    // 🔹 Cart
    const userRollid = JSON.parse(localStorage.getItem("aerialst")) || 0;
    const id = userRollid.id;
    const [data, setData] = useState([]);

    const getAddtoCartData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BACKEND_BASE_URL}/getAddToCart/${id}`
            );
            if (res.status === 200) {
                setData(res.data.data);
            } else {
                setData([]);
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <LocContext.Provider value={{ location, getAddtoCartData, data }}>
            {props.children}
        </LocContext.Provider>
    );
};

export default LocState;
